module.exports = __webpack_public_path__ + "static/media/metters.f4c6252c.jpg";